import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Client } from '@microsoft/microsoft-graph-client';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '@env/environment';
import { User } from './user';
import { LocalStorageService } from '@core/local-storage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public authenticated: boolean;
  public user: User;
  public id: number;


  private OAUTH_SETTINGS = environment.oauth_setting;

  private API_URL_GET_INFO_USER = environment.api_main + 'user'

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(
    private msalService: MsalService,
    private http: HttpClient,
    private _localStorageService:LocalStorageService
  ) {
    this.authenticated = this.msalService.getUser() != null;
    this.user = (this.getLocalUser())? this.getLocalUser():null;

  }

  // Prompt the user to sign in and
  // grant consent to the requested permission scopes
  async signIn(): Promise<void> {

    await this.msalService.loginRedirect(this.OAUTH_SETTINGS.scopes);
  }

  // Sign out
  signOut(): void {
    this.msalService.logout();
    this.user = null;
    this.authenticated = false;
  }

  // Silently request an access token
  async getAccessToken(): Promise<string> {
    let result = await this.msalService.acquireTokenSilent(this.OAUTH_SETTINGS.scopes)
      .catch((reason) => {
      });

    return result;
  }

  async getAuthyId(email): Promise<Object> {
    return await this.http.get(`${this.API_URL_GET_INFO_USER}?email=${email}`, this.httpOptions).toPromise();
  }

  async getInitUser(): Promise<User> {
    if (!this.authenticated) return null;


    if (this.getLocalUser()) return null;


    let token = await this.getAccessToken();

    let graphClient = Client.init({
      // Initialize the Graph client with an auth
      // provider that requests the token from the
      // auth service
      authProvider: async (done) => {
        if (token) {
          done(null, token);
        } else {
          done("Could not get an access token", null);
        }
      }
    });

    // Get the user from Graph (GET /me)
    let graphUser = await graphClient.api('/me').get();

    let user = new User();
    user.displayName = graphUser.displayName;
    // Prefer the mail property, but fall back to userPrincipalName
    user.email = graphUser.mail || graphUser.userPrincipalName;

    return user;
  }


  getLocalUser() {
    return JSON.parse(localStorage.getItem('miUser'));
  }

  setLocalUser(obj: any) {
    localStorage.setItem('miUser', JSON.stringify(obj));
    this.user = this.getLocalUser();
  }
  removeLocalUser() {
    localStorage.removeItem('miUser');
    this.user = this.getLocalUser();
  }

  getId() {
    return this._localStorageService.getItem('id');
  }

  setId(obj: any) {
    this._localStorageService.setItem('id',obj);
    this.id = this.getId();
  }
  removeId() {
    this._localStorageService.removeItem('id');
    this.id = this.getId();
  }


}
